import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@fluentui/react-components';
import { ChevronLeftRegular, ChevronRightRegular } from '@fluentui/react-icons';
import { IconButton, DefaultButton } from '@fluentui/react/lib/Button';
import { StringsMapping } from '../../common/strings';

function ConversionTrackingFooter(props) {
  const {
    newI18n,
    pageNumber,
    setPageNumber,
    router,
    instrumentationLog,
    totalPageCount,
    permissions,
  } = props;

  const manageGoalsText = useMemo(
    () =>
      newI18n.getString(StringsMapping.Footer_ManageConversions),
    [newI18n]
  );

  const pageCount = useMemo(
    () =>
      newI18n.getString(
        StringsMapping.Footer_PageCount,
        { pageNumber: pageNumber + 1 }
      ),
    [newI18n, pageNumber]
  );

  const navigateToConversionGoals = useCallback(() => {
    if (router) {
      if (instrumentationLog) {
        instrumentationLog.ManageConversionsClicked();
      }
      router.navigateToRoute('conversiongoals');
    }
  }, [instrumentationLog, router]);

  const requiredPermission = permissions.dynamic.OverviewPageFluentV2 || permissions.dynamic.OverviewPageFluent2;

  if (totalPageCount === 1) {
    return (
      <div className="carousel-footer">
        <div className="action-button">
          {requiredPermission ? (
            <Button onClick={navigateToConversionGoals}>{manageGoalsText}</Button>
          ) : (
            <DefaultButton onClick={navigateToConversionGoals} text={manageGoalsText} />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-footer">
      <div className="action-button">
        {requiredPermission ? (
          <Button onClick={navigateToConversionGoals}>{manageGoalsText}</Button>
          ) : (
            <DefaultButton onClick={navigateToConversionGoals} text={manageGoalsText} />
          )}
      </div>
      <div className="carousel-pagination">
        <div className="carousel-item-count">
          {pageCount}
        </div>
        {requiredPermission ? (
          <>
            <Tooltip content={newI18n.getString(_TL_('Previous'))} relationship="label">
              <Button className="previous" icon={<ChevronLeftRegular />} appearance="transparent" disabled={pageNumber === 0} onClick={() => setPageNumber(0)} />
            </Tooltip>
            <Tooltip content={newI18n.getString(_TL_('Next'))} relationship="label">
              <Button className="next" icon={<ChevronRightRegular />} appearance="transparent" disabled={pageNumber === 1} onClick={() => setPageNumber(1)} />
            </Tooltip>
          </>
        ) : (
          <div className="carousel-arrows">
            <IconButton
              className="carousel-left"
              iconProps={{ iconName: 'ChevronLeft' }}
              onClick={() => setPageNumber(0)}
              disabled={pageNumber === 0}
              ariaLabel={newI18n.getString(_TL_('Previous page'))}
            />
            <IconButton
              className="carousel-right"
              iconProps={{ iconName: 'ChevronRight' }}
              onClick={() => setPageNumber(1)}
              disabled={pageNumber === 1}
              ariaLabel={newI18n.getString(_TL_('Next page'))}
            />
          </div>
        )
      }
      </div>
    </div>
  );
}

ConversionTrackingFooter.defaultProps = {
  setPageNumber: _.noop,
  router: {
    navigateToRoute: _.noop,
  },
  instrumentationLog: {
    ManageConversionsClicked: _.noop,
  },
  totalPageCount: 1,
};
ConversionTrackingFooter.propTypes = {
  newI18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  pageNumber: PropTypes.number.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      OverviewPageFluentV2: PropTypes.bool,
      OverviewPageFluent2: PropTypes.bool,
    }),
  }).isRequired,
  setPageNumber: PropTypes.func,
  router: PropTypes.shape({
    navigateToRoute: PropTypes.func,
  }),
  instrumentationLog: PropTypes.shape({
    ManageConversionsClicked: PropTypes.func,
  }),
  totalPageCount: PropTypes.number,
};

export default ConversionTrackingFooter;
